import {
  Alert,
  Button,
  Classes,
  Dialog,
  FormGroup,
  H5,
  HTMLTable,
  InputGroup,
  Popover,
  Spinner,
  Switch,
  Tab,
  Tabs,
} from "@blueprintjs/core";
import { computed, observable } from "mobx";
import { observer } from "mobx-react";
import { createViewModel, IViewModel } from "mobx-utils";
import * as React from "react";
import { api_adm } from "../../api";
import { IConta } from "../../model";
import { ContaStore } from "../../stores/admin/ContaStore";
import {
  MDBBtn,
  MDBCol,
  MDBModalBody,
  MDBRow,
} from "mdbreact";
// import "../../../node_modules/@fortawesome/fontawesome-free/css/all.min.css";
// import "../../../node_modules/bootstrap-css-only/css/bootstrap.min.css";
import { copyToClipboard, formatCnpj } from "../../utils";
import CnpjInput from "../utils/CnpjInput";
import {
  BootstrapTable,
  SearchField,
  TableHeaderColumn,
} from "react-bootstrap-table";
import { toast } from "react-toastify";
import CurrencyInput from "../utils/CurrencyInput";
import IntlCurrencyInput from "react-intl-currency-input";
import { PerfilStore } from "../../stores/perfil/PerfilStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import CalculadoraPage from "../calculadora/Calculadora";
import moment from "moment";
import { AppStore } from "../../stores/AppStore";

const numeral = require("numeral");

interface ContaDialogProps {
  conta: IConta;
  onClose: () => void;
}

interface ContaDialogState {
  acomar: boolean
}

@observer
export class ContaDialog
  extends React.Component<ContaDialogProps, ContaDialogState> {

  obs = observable({
    conta: null as IConta | any & IViewModel<IConta>,
    plano_personalizado: [] as any,
    ref_length_usuarios: 0 as number,
    items_planos: [] as any,
    planBasic: false as boolean,
    planBusiness: false as boolean,
  })

  constructor(props) {
    super(props)
    this.state = { acomar: false }
  }
  async componentDidMount() {
    this.obs.conta = observable(this.props.conta);
    this.obs.ref_length_usuarios = this.obs.conta.usuarios.length

    await ContaStore.handleConsultaEmpresas(this.obs.conta._id)
  }

  renderNoData() {
    return (
      <div style={{ textAlign: "center" }}>
        Aguarde... &nbsp; &nbsp; &nbsp;

        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  handleSave = async () => {

    const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/

    if (!this.obs.conta) return;

    if (!this.obs.conta.nome || this.obs.conta.nome == "") {
      toast.error("Por favor, preencha o campo Nome.", {});
      return;
    }

    if (!this.obs.conta.cnpj || this.obs.conta.cnpj == "") {
      toast.error("Por favor, preencha o campo CNPJ.", {});
      return;
    }

    if (!this.obs.conta.logradouro || this.obs.conta.logradouro == "") {
      toast.error("Por favor, preencha o campo Logradouro.", {});
      return;
    }

    if (!this.obs.conta.numero || this.obs.conta.numero == "") {
      toast.error("Por favor, preencha o campo Número.", {});
      return;
    }

    if (!this.obs.conta.bairro || this.obs.conta.bairro == "") {
      toast.error("Por favor, preencha o campo Bairro.", {});
      return;
    }

    if (!this.obs.conta.cidade || this.obs.conta.cidade == "") {
      toast.error("Por favor, preencha o campo Cindade.", {});
      return;
    }

    if (!this.obs.conta.estado || this.obs.conta.estado == "") {
      toast.error("Por favor, preencha o campo UF.", {});
      return;
    }

    if (!this.obs.conta.cep || this.obs.conta.cep == "") {
      toast.error("Por favor, preencha o campo CEP.", {});
      return;
    }

    if (!this.obs.conta.ddd || this.obs.conta.ddd == "") {
      toast.error("Por favor, preencha o campo DDD.", {});
      return;
    }

    if (!this.obs.conta.telefone || this.obs.conta.telefone == "") {
      toast.error("Por favor, preencha o campo Telefone.", {});
      return;
    }

    for (var i = 0; i < this.obs.conta.usuarios.length; i++) {

      let user = this.obs.conta.usuarios[i];

      if (!user.email) {
        toast.error("Por favor, preencha o campo E-mail na aba Usuários.", {});
        return;
      }
      if (!regex.test(user.email)) {
        toast.error("E-mail inválido!", {});
        return;
      }
      if (!user.nome_completo) {
        toast.error("Por favor, preencha o campo Nome na aba Usuários.", {});
        return;
      }
      if (user.processar_senha && !user.senha) {
        toast.error("Por favor, preencha o campo Senha na aba Usuários.", {});
        return;
      }

      if (user.senha && (user.senha.match(/\d/) == null || user.senha.match(/[a-z]/i) == null)) {
        toast.error('A senha do Usuário deve conter números e letras', {});
        return;
      }

      if (user.senha && user.senha.length < 8) {
        toast.error('A senha do Usuário deve conter 8 caracteres', {});
        return;
      }

    }

    this.obs.conta.new_users_count = this.obs.conta.usuarios.length - this.obs.ref_length_usuarios

    try {

      let resp: any = {}

      if (this.obs.conta._id) {

        resp = await api_adm.put(`/api/admin/contas/${this.obs.conta._id}`, this.obs.conta);

      } else {

        resp = await api_adm.post("/api/admin/contas", this.obs.conta);

      }

      if (resp.data.ok) {

        toast.success('Conta atualizada', {});

        await ContaStore.loadContas(1);

        this.props.onClose();

      } else {

        toast.error(`Conta não atualizada: ${resp.data.msg}`, {});

      }

    } catch (ex) {

      toast.error(`Erro ao atualizar Conta!`, {});

    }

  };

  handleChangeCalculo = (e) => {
    const newValue = e.target.checked;
    this.setState({ acomar: newValue })
    this.obs.conta.acomar = newValue;
  };

  renderContaTab() {

    const hanldeDesconto = (event, value, maskedValue) => {
      if (value > 199) {
        toast.error(`Valor máximo permitido de desconto R$ 199,00`, {});
        this.obs.conta.desconto = 0
        return
      }

      this.obs.conta.desconto = value
    }

    const currencyConfig = {
      locale: "pt-BR",
      formats: {
        number: {
          BRL: {
            style: "currency",
            currency: "BRL",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          },
        },
      },
    };

    return (
      <div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <FormGroup
            label="Nome"
            labelInfo="*"
            labelFor="nome"
            style={{ marginRight: 20 }}
          >
            <InputGroup
              id="nome"
              style={{ width: 400 }}
              value={this.obs.conta.nome}
              onChange={(e: any) => this.obs.conta.nome = e.target.value}
            />
          </FormGroup>

        </div>
        <FormGroup
          label="CNPJ"
          labelInfo="*"
          labelFor="cnpj"
          style={{ width: 200 }}
        >
          <CnpjInput
            onChange={val => this.obs.conta.cnpj = val}
            value={this.obs.conta.cnpj}
            disabled={false}
          />
        </FormGroup>

        <div style={{ display: "flex", flexDirection: "row" }}>
          <FormGroup
            label="Rua"
            labelInfo="*"
            labelFor="rua"
            style={{ marginRight: 20 }}
          >
            <InputGroup
              id="rua"
              style={{ width: 350 }}
              value={this.obs.conta.logradouro}
              onChange={(e: any) => this.obs.conta.logradouro = e.target.value}
            />
          </FormGroup>

          <FormGroup
            label="Número"
            labelInfo="*"
            labelFor="numero"
          >
            <InputGroup
              id="numero"
              style={{ width: 120 }}
              value={this.obs.conta.numero}
              onChange={(e: any) => this.obs.conta.numero = e.target.value}
            />
          </FormGroup>

        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <FormGroup
            label="Bairro"
            labelInfo="*"
            labelFor="bairro"
            style={{ marginRight: 20 }}
          >
            <InputGroup
              id="bairro"
              style={{ width: 170 }}
              value={this.obs.conta.bairro}
              onChange={(e: any) => this.obs.conta.bairro = e.target.value}
            />
          </FormGroup>

          <FormGroup
            label="Cidade"
            labelInfo="*"
            labelFor="cidade"
            style={{ marginRight: 20 }}
          >
            <InputGroup
              id="cidade"
              style={{ width: 300 }}
              value={this.obs.conta.cidade}
              onChange={(e: any) => this.obs.conta.cidade = e.target.value}
            />
          </FormGroup>

          <FormGroup
            label="UF"
            labelInfo="*"
            labelFor="uf"
            style={{ marginRight: 20 }}
          >
            <InputGroup
              id="uf"
              style={{ width: 60 }}
              value={this.obs.conta.estado}
              onChange={(e: any) =>
                this.obs.conta.estado = e.target.value.toUpperCase()}
            />
          </FormGroup>

        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <FormGroup
            label="CEP"
            labelInfo="*"
            labelFor="cep"
            style={{ marginRight: 20 }}
          >
            <InputGroup
              id="cep"
              style={{ width: 350 }}
              value={this.obs.conta.cep}
              onChange={(e: any) => this.obs.conta.cep = e.target.value}
            />
          </FormGroup>

        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <FormGroup
            label="DDD"
            labelInfo="*"
            labelFor="ddd"
            style={{ marginRight: 20 }}
          >
            <InputGroup
              id="ddd"
              style={{ width: 60 }}
              value={this.obs.conta.ddd}
              onChange={(e: any) => this.obs.conta.ddd = e.target.value}
            />
          </FormGroup>

          <FormGroup
            label="Telefone"
            labelInfo="*"
            labelFor="telefone"
            style={{ marginRight: 20 }}
          >
            <InputGroup
              id="telefone"
              style={{ width: 350 }}
              value={this.obs.conta.telefone}
              onChange={(e: any) => this.obs.conta.telefone = e.target.value}
            />
          </FormGroup>

          <FormGroup
            label="Desconto Ativação"
            labelFor="desconto"
            style={{ marginRight: 20 }}
          >

            <IntlCurrencyInput
              className="form-control"
              onChange={hanldeDesconto}
              value={this.obs.conta.desconto}
              currency="BRL"
              config={currencyConfig}
            />
          </FormGroup>

        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
        </div>
      </div>
    );
  }

  renderContaPermiTab() {

    return (
      <div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <FormGroup
            label="Status"
            labelFor="ativa"
            style={{ marginRight: 30 }}
          >
            <Switch
              label={this.obs.conta.ativo ? "Conta ativa" : "Conta desativada"}
              checked={this.obs.conta.ativo}
              onChange={(e: any) =>
                this.obs.conta.ativo = e.target.checked ? true : false}
            />
          </FormGroup>

          <FormGroup
            label={this.obs.conta.sefa_new ? "Sefa Java" : "Sefa Java"}
            style={{ marginRight: 30 }}
          >
            <Switch
              label={this.obs.conta.sefa_new ? "Sim" : "Não"}
              checked={this.obs.conta.sefa_new}
              onChange={(e: any) =>
                this.obs.conta.sefa_new = e.target.checked}
            />
          </FormGroup>

          <FormGroup

            label={this.obs.conta.dae_new ? "Dae Avulso Java" : "Dae Avulso Java"}
            style={{ marginRight: 30 }}
          >
            <Switch
              label={this.obs.conta.dae_new ? "Sim" : "Não"}
              checked={this.obs.conta.dae_new}
              onChange={(e: any) =>
                this.obs.conta.dae_new = e.target.checked}
            />
          </FormGroup>

          <FormGroup
            label={this.obs.conta.dec_sefa_new ? "Dec Sefa Java" : "Dec Sefa Java"}
            style={{ marginRight: 30 }}
          >
            <Switch
              label={this.obs.conta.dec_sefa_new ? "Sim" : "Não"}
              checked={this.obs.conta.dec_sefa_new}
              onChange={(e: any) =>
                this.obs.conta.dec_sefa_new = e.target.checked}
            />
          </FormGroup>

        </div>

        <div style={{ display: "flex", flexDirection: "row" }}>
          <FormGroup
            label={this.obs.conta.teste
              ? "Período de Teste"
              : "Ativar Período de Teste?"}
            labelFor="pendente"
            style={{ marginRight: 30 }}
          >
            <Switch
              label={this.obs.conta.teste ? "Ativado" : "Desativado"}
              checked={this.obs.conta.teste}
              onChange={(e: any) =>
                this.obs.conta.teste = e.target.checked ? true : false}
            />
          </FormGroup>

          <FormGroup
            label={this.obs.conta.acomar ? "Desconto Acomar" : "Ativar Desconto Acomar?"}
            labelFor="pendente"
          >
            <Switch
              label={this.obs.conta.acomar ? "Ativado" : "Desativado"}
              checked={this.obs.conta.acomar}
              disabled={!this.obs.conta.id_assinatura}
              onChange={(e: any) =>
                this.handleChangeCalculo(e)}
            />
          </FormGroup>

        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>

          <FormGroup
            label={this.obs.conta.libera_pagamento ? "Pagamento" : "Liberar Pagamento?"}
            labelFor="pendente"
            style={{ marginRight: 30 }}
          >
            <Switch
              label={this.obs.conta.libera_pagamento ? "Liberado" : "Liberar"}
              checked={this.obs.conta.libera_pagamento}
              onChange={(e: any) =>
                this.obs.conta.libera_pagamento = e.target.checked ? true : false}
            />
          </FormGroup>

          <FormGroup
            label={this.obs.conta.libera_contrato ? "Contrato" : "Liberar Contrato?"}
            labelFor="pendente"
          >
            <Switch
              label={this.obs.conta.libera_contrato ? "Liberado" : "Liberar"}
              checked={this.obs.conta.libera_contrato}
              onChange={(e: any) =>
                this.obs.conta.libera_contrato = e.target.checked ? true : false}
            />
          </FormGroup>

        </div>
      </div>
    );
  }

  handleCopyChave = (token: string) => {
    copyToClipboard(token);
    toast.success('Chave de Acesso Copiada', {});
  };

  async handleReset2FA(user) {

    await ContaStore.handleReset2Fa(user._id)

  }

  async handlePlanoPersonalizado() {

    if (!this.obs.plano_personalizado.plano) {
      toast.error('Nome do plano é obrigatório.', {});
      return
    }

    if (!this.obs.plano_personalizado.valor) {
      toast.error('Valor do plano é obrigatório.', {});
      return
    }

    if (!this.obs.plano_personalizado.maximo) {
      toast.error('Máximo Calcular é obrigatório.', {});
      return
    }

    ContaStore.obs.open_edit_plano = false

    await ContaStore.handlePlanoPersonalizado(this.obs.plano_personalizado)

    await ContaStore.handleConsultaEmpresas(this.obs.conta._id)

  }

  renderUsersTab() {
    if (!this.obs.conta) return null;

    let users = this.obs.conta.usuarios?.map(user => {
      return (
        <tr key={user.id}>
          <td>
            <InputGroup
              name='new-email'
              autoComplete='new-email'
              style={{ width: 250 }}
              value={user.email}
              onChange={(e: any) => { user.email = e.target.value; user.edit = true }}
            />
          </td>
          <td>
            <InputGroup
              name='new-nome-completo'
              autoComplete='new-nome-completo'
              style={{ width: 250 }}
              value={user.nome_completo}
              onChange={(e: any) => { user.nome_completo = e.target.value; user.edit = true }}
            />
          </td>
          <td>
            {user.processar_senha ?
              <InputGroup
                name='new-password'
                autoComplete='new-password'
                value={user.senha}
                onChange={(e: any) => { user.senha = e.target.value; user.confirma_senha = user.senha; user.edit = true }}
                type="password"
              />
              :
              <img src="/images/reset-password.png" width={25} onClick={() => { user.processar_senha = true; user.senha = ""; }} style={{ cursor: "pointer", marginTop: 10 }} />
            }
          </td>
          <td>
            <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
              <img src="/images/2fa.png" width={25} style={{ cursor: "pointer", marginTop: 10 }} />
              <div>
                <H5>Confirmar Restauração de 2FA?</H5>
                <p style={{ textAlign: "justify" }}>A restauração de 2FA irá restaurar a autenticação em duas etapas para esta conta. Isso significa que a proteção adicional será removida e você precisará configurar o 2FA novamente para continuar a usá-lo.</p>
                <p>Confirmar a restauração de 2FA?</p>
                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 15, }}>
                  <Button className={Classes.POPOVER_DISMISS} style={{ marginRight: 10 }}>Cancelar</Button>
                  <Button intent="danger" className={Classes.POPOVER_DISMISS} onClick={() => this.handleReset2FA(user)}>Resetar</Button>
                </div>
              </div>
            </Popover>
          </td>
          <td style={{ verticalAlign: "bottom" }}>
            <Switch
              label={user.representante ? "Sim" : "Não"}
              checked={user.representante}
              onChange={(e: any) => { user.representante = e.target.checked; user.edit = true }} />
          </td>
          <td>
            {user.principal &&
              <img src="/images/user.svg" width={25} style={{ marginTop: 10 }} />
            }
          </td>
          <td>
            {user.token_adm &&
              <img src="/images/key.svg" width={22} onClick={() => this.handleCopyChave(user.token_adm)} style={{ cursor: "pointer", marginTop: 10 }} />
            }
          </td>
        </tr>
      );
    });

    return (
      <>
        <Button
          text="Criar usuário"
          onClick={() => {
            this.obs.conta.usuarios.push({ email: "", admin: false, nome_completo: "", processar_senha: true, new: true });
          }}
        />
        <Button
          text="Criar usuário Administrador"
          style={{ marginLeft: 15 }}
          onClick={() => {
            this.obs.conta.usuarios.push({ email: "", admin: true, nome_completo: "", processar_senha: true, new: true });
          }}
        />
        <a
          href="/login/adm"
          role="button"
          target="_blank"
          className="bp3-button"
          style={{ marginLeft: 15 }}
        >
          Acessar Login Adm
        </a>

        <div style={{ overflow: "auto", maxHeight: 400, padding: 10 }}>
          <HTMLTable
            className="table table-hover dataTable"
            style={{ width: "100%", marginTop: 15 }}
            small
          >
            <thead>
              <tr>
                <th style={{ width: "20%" }}>E-mail / Login</th>
                <th style={{ width: "20%" }}>Nome Completo</th>
                <th style={{ width: "20%" }}>Senha</th>
                <th style={{ width: "10%" }}>2FA</th>
                <th style={{ width: "10%" }}>Representante</th>
                <th style={{ width: "10%" }}></th>
                <th style={{ width: "10%" }}></th>
              </tr>
            </thead>
            <tbody>
              {users}
            </tbody>
          </HTMLTable>
        </div>
      </>
    );
  }

  renderPlanoTab() {

    const planBasic = (empresas, faixa) => {

      this.obs.items_planos = { empresas: empresas, faixa: faixa }

      this.obs.planBasic = true
    }

    const itens = Object.keys(ContaStore.obs.empresas_planos)
      .map((faixa) => parseInt(faixa.match(/\d+/)[0]))
      .sort((a, b) => {
        if (a === 0) return -1;
        if (b === 0) return 1;
        return a - b;
      })
      .map((faixa) => {
        const empresasNessaFaixa = ContaStore.obs.empresas_planos[`faixa${faixa}`];

        let valor = empresasNessaFaixa[0].plano.valor

        if (faixa == 0) {
          return (<>
            <MDBCol md="6" key={faixa}>
              <div className="blocoAssin_conta_dialog">
                <span className="descAssinPerfil">Plano <b>SEFIP</b></span>
                <br />
                <br />
                <span className="countAssinPerfil"
                  onClick={() => planBasic(empresasNessaFaixa, faixa)}
                >
                  {empresasNessaFaixa.length <= 1
                    ? empresasNessaFaixa.length + " CNPJ"
                    : empresasNessaFaixa.length + " CNPJs"}
                </span>
              </div>
            </MDBCol>
          </>)
        }

        return (
          <MDBCol md="6" key={faixa}>
            <div className="blocoAssin_conta_dialog">
              <span className="descAssinPerfil">{faixa}ª Faixa</span>
              <span className="priceAssinPerfil"><b>R$</b> {valor}</span>
              <span className="countAssinPerfil"
                onClick={() => planBasic(empresasNessaFaixa, faixa)}
              >
                {empresasNessaFaixa.length <= 1
                  ? empresasNessaFaixa.length + " CNPJ"
                  : empresasNessaFaixa.length + " CNPJs"}
              </span>
            </div>
          </MDBCol>
        );
      });

    return (
      <div style={{ overflow: "auto", maxHeight: 400 }}>
        <MDBCol md="12">
          <h2 className="title">Sua Assinatura</h2>
          <MDBRow>
            {itens}
            <MDBCol md="6">
              <div className="blocoAssin_conta_dialog">
                <span className="descAssinPerfil">
                  Plano <b>Personalizado</b>
                </span>
                <span className="countAssinPerfil" onClick={() => this.obs.planBusiness = true}>
                  {ContaStore.obs.empresas_planos_personalizados.length <= 1
                    ? ContaStore.obs.empresas_planos_personalizados.length + " CNPJ"
                    : ContaStore.obs.empresas_planos_personalizados.length + " CNPJs"}
                </span>
              </div>
            </MDBCol>

            <MDBCol md="6">
              <div className="dadosAssin_conta_dialog">
                <span className="descAssinPerfil">
                  <span className="priceAssinPerfil">
                    <b>R$</b>{" "}
                    {numeral(ContaStore.obs.valortotal_assinatura).format("0,0.00")}
                  </span>{" "}
                  <br />
                  <b>Plano:</b> Mensal <br />
                  <>
                    <br />
                    <b>Próxima Fatura:</b>
                    {" " +
                      ContaStore.obs.expiraem_assinatura.split("-").reverse().join(
                        "/",
                      )}
                  </>
                  <br />
                  <br />
                </span>
              </div>
            </MDBCol>
          </MDBRow>
        </MDBCol>
      </div>
    );
  }

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="input-filter"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar Razão Social, CNPJ..."
      />
    );
  };

  renderContaEmpresasTab() {
    let empresas = ContaStore.obs.empresas_retroativas?.map(emp => {
      return (emp);
    });

    const options = {
      searchField: this.createCustomSearchField,
    };

    const liberaEmpresasRetroativas = async (empresa_id, checked) => {

      await ContaStore.handleLiberaEmpresasRetroativas(empresa_id, checked)

      if (ContaStore.obs.consulta_retroativas) {
        toast.success('Retroativa Atualizada!', {});
      } else {
        toast.error('Erro ao atualizar Retroativa.', {});
      }

      await ContaStore.handleConsultaEmpresas(this.obs.conta._id)
    }

    const ativaEmpresa = async (empresa_id) => {

      await ContaStore.handleAtivaEmpresa(empresa_id)

      if (ContaStore.obs.ativar_empresa) {
        toast.success('Empresa Ativada!', {});
      } else {
        toast.error('Erro ao ativar Empresa.', {});
      }

      await ContaStore.handleConsultaEmpresas(this.obs.conta._id)
    }

    const handlePlanoPersonalizado = async (row) => {

      this.obs.plano_personalizado = []

      this.obs.plano_personalizado = {...row}

      ContaStore.obs.open_edit_plano = true

    }

    function buttonFormatter(cell, row) {
      return (
        <div>
          <Switch
            label={row.calcula_nota_retroativa ? "Liberado" : "Liberar"}
            checked={row.calcula_nota_retroativa}
            onChange={(e: any) => liberaEmpresasRetroativas(row._id, e.target.checked)}
          />
        </div>
      );
    }

    function butFormatter(cell, row) {
      return (
        <div>
          {row.ativo ?
            <></> : <Switch
              label={row.ativa_empresa ? "Ativado" : "Ativar"}
              checked={row.ativa_empresa}
              onChange={(e: any) => ativaEmpresa(row._id)}
            />}
        </div>
      );
    }

    function buttonPlanoFormatter(cell, row) {
      return (<MDBBtn
        color="default"
        rounded
        size="sm"
        onClick={(e) => handlePlanoPersonalizado(row)}
      >
        <img src="/images/view.png" width="18px" />
      </MDBBtn>)
    }

    return (<>

      <Alert
        confirmButtonText="Salvar"
        cancelButtonText="Cancelar"
        intent="primary"
        isOpen={ContaStore.obs.open_edit_plano}
        onClose={() => ContaStore.obs.open_edit_plano = false}
        onConfirm={() => this.handlePlanoPersonalizado()}
        canOutsideClickCancel={true}
      >
        <h2 className="title-cert">Personalizar Plano</h2>

        <div className="">
          <p>Empresa&nbsp;&nbsp;<b>{this.obs.plano_personalizado.razao_social}</b></p>
        </div>

        <div className="">
          <p>CNPJ&nbsp;&nbsp;<b>{formatCnpj(this.obs.plano_personalizado.cnpj)}</b></p>
        </div>

        <FormGroup label="Nome do Plano" labelFor="plano" >
          <InputGroup
            id="plano"
            value={this.obs.plano_personalizado.plano}
            onChange={(e: any) => this.obs.plano_personalizado.plano = e.target.value}
          />
        </FormGroup>
        <div style={{ display: "flex" }}>

          <FormGroup label="Valor Plano" labelFor="valor-plano" style={{ float: "left", marginRight: "15px", width: "50%" }} >
            <CurrencyInput
              value={this.obs.plano_personalizado.valor}
              precision={2}
              showIcon={false}
              onChange={(e) => this.obs.plano_personalizado.valor = e}
            />
          </FormGroup>

          <FormGroup label="Máximo Calcular" labelFor="maximo" style={{ float: "right", width: "50%" }}>
            <CurrencyInput
              value={this.obs.plano_personalizado.maximo}
              precision={2}
              showIcon={false}
              onChange={(e) => this.obs.plano_personalizado.maximo = e}
            />
          </FormGroup>
        </div>

      </Alert>

      <MDBCol md="12">
        <BootstrapTable className="table-retroativas" ref="table" data={empresas} options={options} search>
          <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
          <TableHeaderColumn dataField="razao_social" width="50%">Razão Social</TableHeaderColumn>
          <TableHeaderColumn dataField="cnpj" width="25%">CNPJ</TableHeaderColumn>
          <TableHeaderColumn dataField="status" dataFormat={buttonFormatter} width="15%">Retroativa</TableHeaderColumn>
          <TableHeaderColumn dataField="status" dataFormat={butFormatter} width="15%">Ativa</TableHeaderColumn>
          <TableHeaderColumn dataField="status" dataFormat={buttonPlanoFormatter} width="20%">Plano Personalizado</TableHeaderColumn>
        </BootstrapTable>
      </MDBCol></>)
  }

  renderData() {
    return (
      <Tabs id="tabs">
        <Tab id="conta" title="Conta" panel={this.renderContaTab()} />
        <Tab id="conta-permissoes" title="Permissões" panel={this.renderContaPermiTab()} />
        <Tab id="plano" title="Plano" panel={this.renderPlanoTab()} />
        <Tab id="usuarios" title="Usuários" panel={this.renderUsersTab()} />
        <Tab id="empresas" title="Empresas" panel={this.renderContaEmpresasTab()} />
      </Tabs>
    );
  }


  async handleUpdatePlano() {

    let data = {
      empresa_id: EmpresaStore.obs.empresa_id,
      plano: EmpresaStore.obs.plano
    }

    await ContaStore.updateNextPlano(data);

    this.handleCloseCalculadora()

    this.obs.planBusiness = false
    this.obs.planBasic = false

    this.props.onClose()

  }

  handleCloseCalculadora() {
    EmpresaStore.obs.open_calculadora = false;
    EmpresaStore.obs.rendimento_mensal = 0
    EmpresaStore.obs.valorPlano = null
    EmpresaStore.obs.plano = []
  }

  handleSetOff(emp: any) {

    EmpresaStore.obs.cnpj = emp.cnpj
    EmpresaStore.obs.empresa_id = emp._id

    EmpresaStore.obs.open_calculadora = true;

  }

  render() {
    let title = "Conta";
    if (this.obs.conta) {
      title = this.obs.conta.nome;
    }

    let items_personalizados = ContaStore.obs.empresas_planos_personalizados?.map(emp => {
      return (
        <tr key={emp.cnpj}>
          <td>{emp.razao_social}</td>
          <td>
            {emp.cnpj.replace(
              /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
              "$1.$2.$3/$4-$5",
            )}
          </td>
          <td>{"R$ " + numeral(emp.valor_calculado).format("0,0.00")}</td>
          <td>{"R$ " + numeral(emp.plano.valor).format("0,0.00")}</td>
        </tr>
      );
    });

    return (
      <>
        <Dialog
          isOpen={true}
          title={title}
          onClose={this.props.onClose}
        >
          <div className={Classes.DIALOG_BODY}>
            {this.obs.conta && this.renderData() || this.renderNoData()}
          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button
                text="Salvar"
                intent="primary"
                onClick={this.handleSave}
              />
              <Button text="Cancelar" onClick={this.props.onClose} />
            </div>
          </div>

        </Dialog>

        <Alert
          cancelButtonText="Fechar"
          confirmButtonText="Salvar"
          isOpen={EmpresaStore.obs.open_calculadora}
          onCancel={() => this.handleCloseCalculadora()}
          onConfirm={() => this.handleUpdatePlano()}
          className="AlertUser"
          intent="primary"
        >
          <div style={{ display: 'ruby' }}>
            <img className="iconSEFAZ" src="/images/calculadora.png" width="40px" />
            <h2 className="titleSEFAZ">Selecione seu Plano</h2>
          </div>
          <CalculadoraPage />
        </Alert>

        <Dialog
          isOpen={this.obs.planBasic}
          title="Plano"
          onClose={() => this.obs.planBasic = false}
        >
          <div style={{ height: 520, overflow: "auto" }}>
            <div className={Classes.DIALOG_BODY}>
              <div className="emp-plans">
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th style={{ width: "50%" }}>Empresa</th>
                      <th style={{ width: "20%" }}>CNPJ</th>
                      <th style={{ width: "20%" }}>Calculado ({moment().format("MM/YY")})</th>
                      <th style={{ width: "20%" }}>Plano</th>
                      <th style={{ width: "20%" }}>Valor</th>
                      <th/>
                    </tr>
                  </thead>
                  <tbody>
                    {this.obs.items_planos.empresas?.map(emp => {
                      return (<tr key={emp.cnpj}>
                        <td>{emp.razao_social}</td>
                        <td>{emp.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")}</td>
                        <td>{"R$ " + numeral(emp.valor_calculado).format("0,0.00")}</td>
                        <td>{"R$ " + numeral(emp.plano.valor).format("0,0.00")}</td>
                        <td><span className="btn_plano" onClick={() => this.handleSetOff(emp)}>alterar</span></td>
                      </tr>)
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Dialog>

        <Dialog
          isOpen={this.obs.planBusiness}
          title="Plano Personalizado"
          onClose={() => this.obs.planBusiness = false}
        >
          <div style={{ height: 520, overflow: "auto" }}>
            <div className={Classes.DIALOG_BODY}>
              <div className="emp-plans">
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th style={{ width: "50%" }}>Empresa</th>
                      <th style={{ width: "20%" }}>CNPJ</th>
                      <th>Calculado ({moment().format("MM/YY")})</th>
                      <th>Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items_personalizados}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Dialog>

      </>

    );
  }
}
